import { create } from "zustand";
import { PaginationState, SortingState } from "@tanstack/react-table";

type Updater<T> = T | ((prev: T) => T);

type AdminState = {
  dapPagination: PaginationState;
  setDapPagination: (pagination: Updater<PaginationState>) => void;
  dapSorting: SortingState;
  setDapSorting: (sorting: Updater<SortingState>) => void;
};

export const useAdminStore = create<AdminState>((set) => ({
  dapPagination: {
    pageIndex: 0,
    pageSize: 10,
  },
  setDapPagination: (pagination) =>
    set((state) => ({
      dapPagination:
        typeof pagination === "function"
          ? (pagination as (prev: PaginationState) => PaginationState)(
              state.dapPagination,
            )
          : pagination,
    })),
  dapSorting: [],
  setDapSorting: (sorting) =>
    set((state) => ({
      dapSorting:
        typeof sorting === "function"
          ? (sorting as (prev: SortingState) => SortingState)(state.dapSorting)
          : sorting,
    })),
}));
